module.exports = __webpack_public_path__ + "img/klaviyo-logo.8294320c.png";